import {Component} from '@angular/core';
import {PageInfo} from "../../../shared/model/response/page-info.model";
import {DatePipe} from "@angular/common";
import {PaginatorState} from "primeng/paginator";
import {ReportResponse} from "../../../shared/model/response/report-response";
import {ReportFilterModel} from "../../../shared/model/request/report-filter.model";
import {ReportService} from "../../../service/api/report.service";
import {DropdownAbled} from "../../../shared/interfaces/dropdown-abled";

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    standalone: false
})
export class ReportsComponent implements DropdownAbled<ReportResponse> {

  reportList: ReportResponse[];
  pagination: PageInfo

  reportFilters: ReportFilterModel

  tablehasData: boolean = true

  public mouseEvent: MouseEvent
  selectedReport: ReportResponse

  constructor(
    private datePipe: DatePipe,
    private reportService: ReportService,
  ) {
  }

  ngOnInit() {

  }

  onFilterSubmit(filterData: ReportFilterModel) {
    filterData.reportDate = this.datePipe.transform(filterData.reportDate, 'yyyy-MM-dd');
    this.reportFilters = filterData
    this.apiListReports(this.reportFilters)
  }

  onPageChange($event: PaginatorState) {
    this.apiListReports(this.reportFilters, $event.page)
  }

  setTableNoData() {
    this.tablehasData = false;
    this.reportList = null;
  }


  //api calls ----------------------------------
  apiListReports(filters: ReportFilterModel, page?: number) {
    this.reportService.page(page, filters).subscribe({
      next: (value) => {
        this.reportList = value?.data
        this.pagination = value.pageInfo
        this.tablehasData = this.reportList.length > 0
      },
      error: () => {
        if (page == 0) this.setTableNoData()
      }
    })
  }

  onCloseComplaintSuccess($closedComplaint: ReportResponse) {
    this.reportList = this.reportList.filter(el => el.id !== $closedComplaint.id)
    if (this.reportList.length == 0) this.setTableNoData()
  }

  //dropdown interface -------------------------
  selectObjectForDropDown(selectedObject: ReportResponse): void {
    this.selectedReport = selectedObject;
  }

  setMouseEvent($mouseEvent: MouseEvent) {
    this.mouseEvent = $mouseEvent
  }
}
